import { render, staticRenderFns } from "./MarkdownContainer.vue?vue&type=template&id=3e6799dd&"
import script from "./MarkdownContainer.vue?vue&type=script&lang=ts&"
export * from "./MarkdownContainer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports